export default function PageHeader({
  title,
  subTitle,
  trailing,
}: {
  title: string;
  subTitle?: string;
  trailing?: any;
}) {
  return (
    <div className="c2 mc1 gap10 acenter">
      {/* <div className="double">
          <BetaBand></BetaBand>
        </div> */}
      <div>
        <h2>{title}</h2>
        <div className="gray">{subTitle}</div>
      </div>
      {trailing}
    </div>
  );
}
